import wootAPI from '../api/apiClient';
import { readMarketingConsent } from './SignupAttribution';

export const syncMarketingConsent = async () => {
  const consent = readMarketingConsent();
  if (!consent) return;

  await wootAPI.put('api/v1/profile', {
    profile: { marketing_consent: consent },
  });
};
